import cx from 'classnames';
import { Segment, VerticalSpacer } from '../core/core';
import styles from '../SCSS/ClassroomDashboard.module.scss';
import utilityStyles from '../SCSS/common/utilityStyles.module.scss';
import segmentStyles from '../SCSS/Segment.module.scss';
import PrimaryButton from '../components/PrimaryButton/PrimaryButton';
import classroomScreenshot from '../images/example-classroom.png';
import classroomScreenshotMobile from '../images/example-classroom-mobile.png';
import { useHistory } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

interface Props {
  marketingCopy: string;
}

const MarketingClassroom = ({ marketingCopy }: Props): JSX.Element => {
  const history = useHistory();
  const isMobile = useMediaQuery({ maxWidth: 668 });

  return (
    <>
      <div className={`${styles.ClassroomDashboard} ${utilityStyles.clearfix}`}>
        <VerticalSpacer ems={2} />
        <Segment className={utilityStyles.line}>
          <div className={segmentStyles.moduleTitle}>Classroom Settings Example</div>
        </Segment>
        <Segment className={utilityStyles.line}>
          <div className={styles.marketingCopy}>
            <p>{marketingCopy}</p>
            <p>Curious to try out Peekapak PRO? Why not start a free 14-day trial?</p>
            <div className='ctaButton'>
              <PrimaryButton onClick={() => history.push('/activateTrial')}>Start Trial</PrimaryButton>
            </div>
          </div>
          <img
            alt='Screenshot'
            className={cx(utilityStyles.marketingScreenshot, styles.marketingImg)}
            src={isMobile ? classroomScreenshotMobile : classroomScreenshot}
          />
        </Segment>
      </div>
    </>
  );
};

export default MarketingClassroom;
